<efp-collapsable-menu
  *ngIf="(hasNavigation || isHomeScreen) && !disablePrimaryMenu"></efp-collapsable-menu>

<ion-header>
  <ion-toolbar>
    <ion-row>
      <ion-col class="flex-1">
        <ion-buttons class="d-flex nav-button-wrapper">
          <efp-open-menu-button
            *ngIf="(hasNavigation || isHomeScreen) && !disablePrimaryMenu"
            [ngClass]="{ 'media-mobile-only': !webCollapsableEnabled }"></efp-open-menu-button>
          <ng-container>
            <ng-content select="#logo"></ng-content>
          </ng-container>
          <button
            class="headerbar-action"
            *ngIf="hasNavigation"
            (click)="navigate()"
            [disabled]="navDisabledAndGray"
            data-test-selector="header-navigate">
            <div class="headerbar-action-icon" *ngIf="isNavStep">home</div>
            <div class="headerbar-action-icon" *ngIf="!isNavStep">arrow_back</div>
          </button>
          <button
            class="action-icon"
            *ngIf="isModal"
            (click)="dismiss()"
            [disabled]="navDisabledAndGray"
            data-test-selector="header-dismiss">
            close
          </button>
        </ion-buttons>
      </ion-col>
      <ion-col class="ion-text-center ion-justify-content-center flex-3 overflow-trunc">
        <ion-title
          class="overflow-hidden removeInlinePadding"
          [ngClass]="{ 'show-title-on-web': showTitleOnWeb }">
          {{ title }}
          <div class="badge" *ngIf="isReadOnly$ | async">
            <div class="badge-content">
              <span class="badge-icon">edit_off</span>
              <span class="badge-label">{{ 'HOME.READ_ONLY' | translate }}</span>
            </div>
          </div>
        </ion-title>
      </ion-col>
      <ion-col class="flex-1 gap-4 ion-justify-content-end">
        <efp-request-sync-indicator *ngIf="showSyncIndicator"></efp-request-sync-indicator>
        <div class="gap-2 d-flex">
          <efp-reset-onboarding-button></efp-reset-onboarding-button>
          <ng-content></ng-content>
          <ion-buttons>
            <ng-content select="[buttons]"></ng-content>
          </ion-buttons>
        </div>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>
